import styled from 'styled-components';
import { Button } from '../../../Components/uielements';
import { palette } from 'styled-theme';

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const OptionItem = styled.div`
  background-color: rgba(40, 40, 40, 0.9);
  border: 1px solid rgba(60, 60, 60, 0.8);
  border-radius: 8px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background-color: rgba(50, 50, 50, 0.95);
    border-color: rgba(80, 80, 80, 0.9);
  }
`;

export const OptionText = styled.span`
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  flex: 1;
`;

export const ENVDWrapper = styled.div`
  min-height: 100vh;
  padding: 20px;
  color: #ffffff;

  .form-content {
    max-width: 1200px;
    margin: 0 auto;
    border-radius: 4px;
    padding: 30px;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Space Grotesk Regular', sans-serif;
  font-style: normal;
`;

export const BackButton = styled(Button)`
  border: 1.5px solid ${palette('white', 0)} !important;
  background: ${palette('background', 0)} !important;
  color: ${palette('text', 1)} !important;
  max-width: fit-content;
  &:hover,
  :focus {
    background: ${palette('background', 0)} !important;
    border: 1.5px solid ${palette('white', 0)} !important;
    color: ${palette('text', 1)} !important;
  }
`;
